/**
 * TanStack Query hooks for `real-time-roi-measurement-per-creator`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	realTimeRoiMeasurementPerCreatorQueryKeys,
	type CreateRealTimeRoiMeasurementPerCreatorBody,
	type ListRealTimeRoiMeasurementPerCreatorResponse,
	type RealTimeRoiMeasurementPerCreatorRow,
} from "./api";

export function useRealTimeRoiMeasurementPerCreatorList(): UseQueryResult<ListRealTimeRoiMeasurementPerCreatorResponse, Error> {
	return useQuery({
		queryKey: realTimeRoiMeasurementPerCreatorQueryKeys.list(),
		queryFn: list,
	});
}

export function useRealTimeRoiMeasurementPerCreatorCreate(): UseMutationResult<RealTimeRoiMeasurementPerCreatorRow, Error, CreateRealTimeRoiMeasurementPerCreatorBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeRoiMeasurementPerCreatorQueryKeys.all });
		},
	});
}

export function useRealTimeRoiMeasurementPerCreatorDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: realTimeRoiMeasurementPerCreatorQueryKeys.all });
		},
	});
}
